var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from 'angular-ts-decorators';
import { asRequestBody } from '../../shared/util/as-request-body';
import { resetLoadingBtns, setLoadingBtn } from '../../shared/util/loading-button-util';
import { sendOneTimeLoginCode } from '../../shared/util/login-util';
let VerifyOneTimeLoginCodeController = class VerifyOneTimeLoginCodeController {
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = [];
    /** Current value of the login code, required for clean password-bullet handling */
    loginCode = '';
    codeInput;
    submitLoginCode;
    mask;
    constructor() { }
    ngOnInit() {
        document.getElementById('requestNewLoginCodeText').addEventListener('click', this.sendNewLoginCode);
        this.codeInput = document.getElementById('code-input');
        this.submitLoginCode = document.getElementById('submitLoginCode');
        this.mask = document.getElementById('code-mask');
    }
    ngOnDestroy() {
        document.getElementById('requestNewLoginCodeText').removeEventListener('click', this.sendNewLoginCode);
    }
    preventInvalidTwoFactorCodeInput(e) {
        if (new RegExp('[^a-zA-Z0-9]', 'g').test(e.key ?? '#')) {
            e.preventDefault();
        }
    }
    onLoginCodeChanged() {
        const text = this.loginCode;
        if (text.length === 6) {
            // Hide the blinking input caret because it would appear past the last character after maximum is already reached
            this.codeInput.classList.add('hide-input-caret');
            // Focus on the submit button to allow for quick submission and hide
            // extra space after last character where caret would appear
            this.submitLoginCode.focus();
        }
        else {
            this.codeInput.classList.remove('hide-input-caret');
        }
        if (document.getElementById('invalidLoginCode').style.display === 'block') {
            this.clearErrors(['invalidLoginCode']);
        }
        this.mask.innerHTML = text + '•'.repeat(6 - text.length);
    }
    async verifyOneTimeLoginCode(e) {
        if (e) {
            setLoadingBtn(e);
        }
        this.clearAllErrors();
        const formData = new FormData(document.getElementById('loginCodeForm'));
        if (formData.get('code').length !== 6) {
            this.showError('INVALID_MAGIC_LOGIN_CODE');
            resetLoadingBtns();
            return;
        }
        const body = asRequestBody(formData);
        // Pass query params like redirect url to the server request
        const response = await fetch('/one-time-login-code/verify' + window.location.search, {
            method: 'POST',
            body,
        });
        const responseJson = await response.json();
        if (response.ok && responseJson.redirectUrl) {
            window.location.href = responseJson.redirectUrl;
            return;
        }
        else {
            this.showError(responseJson.error);
        }
        resetLoadingBtns();
    }
    sendNewLoginCode = async (e) => {
        if (e) {
            setLoadingBtn(e);
        }
        const formData = new FormData(document.getElementById('loginCodeForm'));
        const body = asRequestBody(formData);
        try {
            await sendOneTimeLoginCode(body, false);
        }
        catch (error) {
            this.clearErrors(['loginDisabled', 'codeSentRecently']);
            switch (error.message) {
                case 'INVALID_EMAIL':
                    // Shouldn't really happen unless query params are tampered with, so send them back to the start.
                    const urlParams = new URLSearchParams(window.location.search);
                    urlParams.set('error', 'INVALID_STATE');
                    window.location.href = '/one-time-login-code/send?' + urlParams;
                    return;
                case 'MAGIC_CODE_LOGIN_DISABLED':
                    document.getElementById('loginDisabled').style.display = 'block';
                    return;
                case 'MAGIC_CODE_ALREADY_SENT':
                    document.getElementById('codeSentRecently').style.display = 'block';
                    return;
                default:
                    // Shouldn't really happen
                    console.error(error);
                    window.alert('UNEXPECTED_ERROR');
                    return;
            }
        }
        finally {
            resetLoadingBtns();
        }
        this.clearAllErrors();
        this.clearCodeInput();
    };
    clearCodeInput() {
        this.codeInput.value = '';
        this.codeInput.dispatchEvent(new Event('input'));
    }
    showError(error) {
        switch (error) {
            case 'INVALID_MAGIC_LOGIN_CODE':
                this.codeInput.classList.add('error');
                document.getElementById('invalidLoginCode').style.display = 'block';
                break;
            case 'EXPIRED_MAGIC_LOGIN_CODE':
                this.codeInput.classList.add('error');
                document.getElementById('expiredLoginCode').style.display = 'block';
                break;
            case 'BAD_REQUEST':
                // Either email or login code are malformed which shouldn't happen unless query params / input are tampered
                // with, so just redirect to the send code page to restart process.
                window.location.href = '/one-time-login-code/send' + window.location.search + '&error=INVALID_STATE';
                break;
            case 'ACCOUNT_LOCKED':
                document.getElementById('accountLocked').style.display = 'block';
                break;
            case 'USER_NOT_FOUND':
                document.getElementById('userNotFound').style.display = 'block';
                break;
            case 'FORBIDDEN_FOR_NON_LOGIN_USER':
                document.getElementById('nonLoginUser').style.display = 'block';
                break;
            case 'FORBIDDEN_FOR_TERMINAL_USER':
                document.getElementById('terminalUser').style.display = 'block';
                break;
            default:
                console.error('Unexpected error while verifying one-time login code:', error);
                window.alert('UNEXPECTED_ERROR');
        }
    }
    /**
     * Hides the error message elements of the specified errors and removes the red border from the code input if
     * applicable.
     *
     * @param {string[]} errorElementIds
     */
    clearErrors(errorElementIds) {
        for (const errorElementId of errorElementIds) {
            if (errorElementId === 'invalidLoginCode' || errorElementId === 'expiredLoginCode') {
                this.codeInput.classList.remove('error');
            }
            document.getElementById(errorElementId).style.display = 'none';
        }
    }
    clearAllErrors() {
        this.clearErrors([
            'invalidLoginCode',
            'expiredLoginCode',
            'accountLocked',
            'userNotFound',
            'nonLoginUser',
            'terminalUser',
            'loginDisabled',
            'codeSentRecently',
        ]);
    }
};
VerifyOneTimeLoginCodeController = __decorate([
    Component({
        selector: 'app-verify-one-time-login-code',
        // no associated template, is embedded static HTML-page in the server assets
    }),
    __metadata("design:paramtypes", [])
], VerifyOneTimeLoginCodeController);
export { VerifyOneTimeLoginCodeController };
